<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ybOI20/tc-custom/9781631942693.jpg?1731056143680" alt="This image is the cover for the book Smoke Without Fire"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Smoke Without Fire
      </h1>
      <p class="bookDescription body article font2">
        <b>A retired professor spends Christmas in a not-so-peaceful English village in this wryly witty mystery with “a surprising and satisfying conclusion” (<i>Publishers Weekly</i>).</b><br/>  <br/> Andrew Basnett does not have very good luck with Christmas. Most recently, while visiting friends in Australia for the festive season, he wound up with a front-row seat to some rather extraordinary family strife. And this time around, his plans for a peaceful English-village holiday get blown up when. . . . well, when his hosts’ neighbor, Sir Lucas Dearden, gets blown up. <br/>  <br/> This is England in the 1980s; everyone shudders, blames the IRA, and moves on. Except, of course, for Andrew Basnett. Who knew, he wonders, about Sir Lucas’s last-minute change of plans? Why had Sir Lucas meticulously removed one page of the (rather stunningly dull) memoir he was writing? And could the bomb possibly have been intended for someone else?<br/>  <br/> “Ferrars has published more than sixty books and the craftsmanship of this one shows why her popularity endures.” —<i>Publishers Weekly</i><br/>  <br/> “There are few detective-story writers so consistently good.” —<i>Sunday Times</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        E.X. Ferrars
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Felony & Mayhem
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?73396572